import { Lock } from "lucide-react";

export function NoAccessBlock({
  description = "Essa área é restrita a quem tem a permissão necessária.",
}: {
  description?: string;
}) {
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-14 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-zinc-100 text-zinc-400 dark:bg-muted dark:text-muted-foreground">
        <Lock className="h-6 w-6" />
      </div>
      <h3 className="max-w-md text-sm font-semibold text-zinc-900 dark:text-foreground">
        Sem acesso a essa área
      </h3>
      <p className="max-w-md text-[12.5px] leading-relaxed text-zinc-500 dark:text-muted-foreground">
        {description}
      </p>
    </div>
  );
}
